module.exports = __webpack_public_path__ + "media/src/images/icons/thumb_down-9196eb25edf41f5b490f7fbf875672ef.svg";